import React, { useCallback, useRef, useState } from 'react';
import { StyledChatInputForm } from './ChatInput.style';
import { IconButton, TextareaAutosize } from '@mui/material';
import CommonSvg, { svgNames } from '@/Components/atoms/CommonSvg';
import { useTranslation } from 'next-i18next';
import { IoMdSend } from 'react-icons/io';
import { PickLocationModal } from '@/Components/moleculas/PickLocationModal';
import { useUserData } from '@/Hooks/useUserData';

type Props = {
  onSendText: (msg: string) => Promise<void>;
  onSendLocation: (lat: number, long: number) => Promise<void>;
  loading: boolean;
}

const ChatInput = ({ onSendText, onSendLocation, loading }: Props) => {
  const { t } = useTranslation();
  const formRef = useRef<HTMLFormElement>(null);
  const [modal, setModal] = useState<null | 'location'>(null);
  const userData = useUserData()!;

  const sendMessage: React.FormEventHandler<HTMLFormElement> = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target as HTMLFormElement);
    const message = formData.get('message') as string;
    if(message) {
      await onSendText(message);
      // TODO FIX speed
      formRef.current?.reset();
    }
  }

  const openLocationModal: React.MouseEventHandler<HTMLButtonElement> = (event) => {
    setModal('location');
    event.currentTarget.blur();
  }

  const closeModal = useCallback(() => {
    setModal(null);
  }, [])

  const pickAndSendLocation = useCallback((lat: number, long: number) => {
    onSendLocation(lat, long);
    closeModal();
  }, [onSendLocation]);

  return (
    <>
      <StyledChatInputForm className='chat-input' onSubmit={sendMessage} ref={formRef}>
        <IconButton onClick={openLocationModal} type='button' className='chat-input__share-location-btn' disableRipple disabled={loading}>
          <CommonSvg name={svgNames.Location} />
        </IconButton>
        <input name='message' className='chat-input__input' placeholder={t('message')!} />
        <IconButton type='submit' className='chat-input__send-text-btn' disableRipple disabled={loading}>
          <IoMdSend />
        </IconButton>
      </StyledChatInputForm>
      <PickLocationModal
        open={modal === 'location'}
        defaultCoords={{ lat: userData.lat, long: userData.lang }}
        onClose={closeModal}
        onSelect={pickAndSendLocation}
      />
    </>
  )
}

export default ChatInput;
